import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetPasswordRoutingModule } from './reset-password-routing.module';
import { HeaderModule } from '../../../shared/header/header.module';
import { FooterModule } from '../../../shared/footer/footer.module';
import { ResetPasswordComponent } from './reset-password.component';
import { I18nService } from '../../../services/i18n.service';
import { NotificationService } from '../../../services/notification.service';
import { NgZorroAntdModule } from '../../../modules/nz-zorro-antd.module';
import { NgZorroIconModule } from '../../../modules/nz-icon-antd.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UtilityService } from '../../../services/utility.service';
import { ValidationErrorsModule } from '../../../shared/validation-errors/validation-errors.module';
import { InputFieldModule } from 'src/app/shared/input-field/input-field.module';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordFieldModule } from "../../../shared/password-field/password-field.module";

@NgModule({
	declarations: [
		ResetPasswordComponent
	],
	imports: [
		CommonModule,
		ResetPasswordRoutingModule,
		ReactiveFormsModule,
		HeaderModule,
		FooterModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		ValidationErrorsModule,
		InputFieldModule,
		TranslateModule,
		PasswordFieldModule
	],
	providers: [
		NotificationService,
		I18nService,
		UtilityService
	],
	exports: [
		ResetPasswordComponent
	]
})

export class ResetPasswordModule { }
